module.exports = __webpack_public_path__ + "static/media/left.ac29bb66.svg";